import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button, ReyPopper } from '@framework-controls/core';
import { strings } from 'src/localization';
import * as css from './MenuVehicle.module.scss';
import classNames from 'classnames';
import { ApptVeh, VehicleRec, UpdateApptVehInp, VehicleStockPhoto, PhotoList, SpecData } from 'src/models';
import VehicleCard from 'src/components/VehicleCard/VehicleCard';
import SVPButton from 'src/components/SVPButtons/SVPButton';
import { IAppointmentState } from 'src/store/states';

export interface Iprops {
    openFlag: boolean;
    close: (e: any) => void;
    apptVeh: ApptVeh;
    updateApptVehicle: (inp: UpdateApptVehInp) => void;
    getPhoto?: (year: string, make: string, model: string, id: string) => void;
    vehiclePhoto?: VehicleStockPhoto;
    vehPhotoList?: PhotoList;
    anchorEl: HTMLElement;
    theme: string;
    showVehRef: React.RefObject<HTMLDivElement>
    newVehicleMileage: string,
    prevMileage: number,
    Itype: string | undefined;
    appointment: IAppointmentState;
    specData?: SpecData;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
}

const MenuVehicle = (props: Iprops) => {
    // const [Varwidth, setWidth] = useState(props.anchorEl.offsetWidth);
    let VarWidthDefault = '';
    if (props.anchorEl) {
        VarWidthDefault = window.getComputedStyle(props.anchorEl).width;
    }
    const [Varwidth, setWidth] = useState(VarWidthDefault);
    const [checkToplineRight, setToplineRight] = useState(false);
    // const [Varwidth, setWidth] = useState(window.getComputedStyle(props.anchorEl).width);

    // Refs are always null in react test renderer, so in order to properly test we need to set a default ref value
    const initialValue: HTMLDivElement = document.createElement('div');
    const menuVehicleRef = useRef<HTMLDivElement>(initialValue);
    const [flyoutWidth, setFlyoutWidth] = useState(props.anchorEl?.offsetWidth);
    const vehicle: VehicleRec = useMemo(() => ({
        id: '',
        vin: props.apptVeh.vin,
        makeCode: props.apptVeh.makeCode,
        make: props.apptVeh.make,
        model: props.apptVeh.model,
        imagePath: props.apptVeh.imagePath,
        year: props.apptVeh.vehYr,
        color: props.apptVeh.vehColor,
        style: props.apptVeh.series,
        prevMileage: props.apptVeh.mileage,
        prevRoDate: '',
        nextAppt: '',
        lastAdv: '',
        lastAdvName: '',
        lastAdvImage: '',
        lastTrans: '',
        lastTransLit: '',
        nameId: '',
    }), [
        props.apptVeh.imagePath,
        props.apptVeh.make,
        props.apptVeh.mileage,
        props.apptVeh.model,
        props.apptVeh.series,
        props.apptVeh.vehColor,
        props.apptVeh.vehYr,
        props.apptVeh.vin,
        props.apptVeh.makeCode,
    ]);

    const changePrevMileage = useCallback((_: string, mileage: number) => {
        let convtMileage = mileage;
        if (isNaN(convtMileage)) {
            convtMileage = 0;
        }

        const inp: UpdateApptVehInp = {
            vin: vehicle.vin,
            makeCode: vehicle.makeCode,
            make: vehicle.make,
            model: vehicle.model,
            series: vehicle.style,
            vehYr: vehicle.year,
            vehColor: vehicle.color,
            mileage: convtMileage,
            imagePath: vehicle.imagePath,
        };
        props.updateApptVehicle(inp);
    }, [vehicle, props.updateApptVehicle]);

    const handleClickOutside = useCallback((e: any) => {
        if (!menuVehicleRef.current?.contains(e.target as Element) && !props.showVehRef.current?.contains(e.target as Element)) {
            props.close(e);
        }
    }, [menuVehicleRef, props.close, props.showVehRef]);

    useEffect(() => {
        if (props.openFlag) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [props.openFlag, handleClickOutside]);

    const menuContentClasses = classNames(
        css.menuContent,
        {
            [css.menuMini]: props.theme === 'mini',
            [css.menuChevrolet]: props.theme === 'chevrolet',
            [css.menuBuick]: props.theme === 'buick',
            [css.menuMB]: props.theme === 'mercedesBenz',

        },
    );

    // the initial width of the vehicle flyout content is zero
    // use setTimeout to get the width of the vehicle flyout after the flyout opens.
    useEffect(() => {
        const timer = setTimeout(() => {
            const width = menuVehicleRef.current?.offsetWidth ?? 0;
            setFlyoutWidth(width);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    // repull offsetWidth on window resize
    const varWidthNumber = parseFloat(Varwidth);
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.getComputedStyle(props.anchorEl).width);
            setFlyoutWidth(menuVehicleRef.current?.offsetWidth);
        };
        if (props.theme === 'toyotaSPM' && varWidthNumber > 404){
            setToplineRight(true);
        } else {
            setToplineRight(false);
        }
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [props.anchorEl, varWidthNumber, props.theme]);



    // const width = props.anchorEl.offsetWidth;
    // const width = window.getComputedStyle(props.anchorEl).width;
    // console.log('width', width);
    // console.log('width', props.anchorEl.offsetWidth);
    // console.log('widthTest', widthTest);
    // console.log('test', props.anchorEl);
    // console.log('test2', props.showVehRef);

    let width2 = 'calc(100% - ' + Varwidth + ' - 2px)';
    const width3 = (2 + props.anchorEl?.offsetWidth - flyoutWidth);
    const style = getComputedStyle(document.body);
    let varBordercolor = style.getPropertyValue('--IconTextColor');
    let varMargin = '0px';
    if (props.theme === 'toyotaSPM' && varWidthNumber > 410) {
        varBordercolor = style.getPropertyValue('--IconTextColor');
        varMargin = '-2px';
    } else if (varWidthNumber > 421) {
        width2 = '2px';
        varBordercolor = style.getPropertyValue('--menuSelected');
        varMargin = '-2px';
    }

    const closeLitClass = classNames(
        css.closeLit,
        {
            [css.closeLitBMW]: props.theme === 'bmw',
            [css.closeLitFord]: props.theme === 'ford',
            [css.closeLitHonda]: props.theme === 'honda',
            [css.closeLitIN]: props.theme === 'infiniti',
            [css.closeLitMB]: props.theme === 'mercedesBenz',
            [css.closeLitAcura]: props.theme === 'acura',
        },
    );

    const closeBtn = props.theme === 'audi' ?
        <SVPButton
            id='cancelBtn'
            variant={'secondaryBtnAlt'}
            message={strings.Close}
            handler={props.close}
            theme={props.theme}
            noArrow={true}
        /> :
        <Button
            variant={'text'}
            id='cancelBtn'
            onClick={props.close}>
            <div className={closeLitClass}>{strings.Close}</div>
        </Button>;

    return (
        <ReyPopper
            className={css.menuVehiclePane}
            isOpen={props.openFlag}
            transition
            placement='bottom-end'
            anchorEl={props.anchorEl}
        >
            <div id='VehicleFlyoutContent' className={menuContentClasses} ref={menuVehicleRef} data-testid='refdiv'>
                <div className={css.container}>
                    <div className={css.toplineArea}>
                        {checkToplineRight ?
                            (<div className={css.toplineRight} data-testid='toplineRight-div'
                                style = {{width: width3, borderColor: varBordercolor, marginLeft: varMargin}}>
                            </div>) :
                            (<div className={css.toplineLeft} data-testid='toplineLeft-div'
                                style={{width: width2, borderColor: varBordercolor, marginLeft: varMargin}}>
                            </div>)}
                    </div>
                    <div className={css.VehDiv}>
                        <VehicleCard
                            vehicle={vehicle}
                            updateMileageState={changePrevMileage}
                            menu={true}
                            theme={props.theme}
                            newVehicleMileage={props.newVehicleMileage}
                            prevMileage={props.prevMileage}
                            apptMileage={0}
                            cancellingAppointment={false}
                            Itype={props.Itype}
                            specData={props.specData}
                            sessionId = {props.sessionId}
                            lexusMCLaunched = {props.lexusMCLaunched}
                            lexusTDMCLaunched = {props.lexusTDMCLaunched}
                            toyotaMCLaunched = {props.toyotaMCLaunched}
                            toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
                            appointment = {props.appointment}
                        />
                    </div>
                    <div className={css.btnArea}>
                        <div className={classNames(css.closeBtnWrap,
                            { [css.closeBtnWrapAudi]: props.theme === 'audi' })}>
                            {closeBtn}
                        </div>
                    </div>
                </div>
            </div >
        </ReyPopper>
    );
};

export default MenuVehicle;